var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"align-center buscador-listado"},[_c('add-to-selected',{staticClass:"d-none d-md-block"}),(_vm.buscar_por_nombre)?_c('name-search'):_c('barcode-search')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }